<template> 
    <div>
        <div class="pageTitleWrap">
            <vs-breadcrumb :items="breadcrumb" class="marLeft12"></vs-breadcrumb>
        </div>  
        <form id="data-list-list-view">              
            <div class="firstTitle">仓库信息</div>
            <div class="flex items-center marBottom20" v-if="warehouseType != warehouseList[1].id">                
                <span class="form-label"><span class="redText">*</span>关联仓库</span>
                <div class="width200">
                    <gc-cmp-form-select v-model="warehouseObj.relWsId" :options="relationWsOptions" class="marLeft16 select" select-placeholder="请选择关联仓库" label=""/>
                </div>
            </div>
            <div class="flex items-center marBottom20">
                <span class="form-label">总仓主体</span>
                <div class="marLeft16" style="padding: .7rem;">{{warehouseObj.bodyName}}</div>
            </div>
            <div class="flex items-center marBottom20">
                <span class="form-label"><span class="redText">*</span>仓库名称</span>
                <vs-input size="middle" v-validate="'required'" placeholder="请输入仓库名称" name="name" maxlength="40" v-model="warehouseObj.name" class="marLeft16" />
                <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('仓库名称') }}</span>
            </div>
            <div class="flex items-center marBottom20">
                <span class="form-label">负责人</span>
                <vs-input size="middle" name="contact"
                         v-model="warehouseObj.contact" class="marLeft16" />
            </div>
            <div class="flex items-center marBottom20">
                <span class="form-label">联系方式</span>
                <vs-input size="middle" name="phone" class="marLeft16"
                          v-model="warehouseObj.phone" maxlength="11" />
            </div>
            <div class="flex items-center marBottom20">
                <span class="form-label">仓库位置</span>
                <vs-input size="middle" name="address" v-model="warehouseObj.address" 
                        class="marLeft16" />
                <!-- <gc-cmp-form-select v-model="warehouseObj.role" :options="roles" ref="form_select"
                                    select-placeholder="请选择角色" label="角色"

                /> -->
            </div>

            <div class="loc-container" v-if="warehouseType === warehouseList[2].id">
                <div class="firstTitle">仓位信息</div>
                <div class="loc-item" v-for="(item, index) in locList" :key="index">
                    <div class="flex items-center marBottom20">
                        <span class="form-label">仓位{{index + 1}}</span> <span class="loc-del" @click="delLoc(index)">删除</span>
                    </div>
                    <div class="flex items-center marBottom20">
                        <span class="form-label"><span class="redText">*</span>仓位名称</span>
                        <vs-input size="middle" v-validate="'required'" placeholder="请输入仓位名称" name="name" v-model="item.name" class="marLeft16" />
                        <span class="text-danger text-sm" v-show="errors.has('name')">{{ errors.first('仓位名称') }}</span>
                    </div>
                    <div class="flex items-center marBottom20">
                        <span class="form-label">负责人</span>
                        <vs-input size="middle" name="contact"
                                v-model="item.contact" class="marLeft16" />
                    </div>
                    <div class="flex items-center marBottom20">
                        <span class="form-label">联系方式</span>
                        <vs-input size="middle" name="phone" class="marLeft16"
                                v-model="item.phone" maxlength="11" />
                    </div>
                    <div class="flex items-center marBottom20">
                        <span class="form-label">仓库位置</span>
                        <vs-input size="middle" name="address" v-model="item.address" 
                                class="marLeft16" />
                    </div>
                </div>
                <vs-button class="add-loc" type="border" @click.prevent="addLoc">新增仓位</vs-button>
            </div>             
            


            <vs-button type="filled" @click.prevent="saveWarehouse">保存</vs-button>
            <vs-button type="border" @click.prevent="cancleAffirm" class="marLeft16">取消</vs-button>
        </form>
    </div>   
</template>    

<script>
  import {
      WmsWarehouseApi, Mod_Warehouse_Types_Options
  } from "@/modules/server-api/wms-manage/warehouse";
  import GcCmpFormSelect from "@/group-cloud/components/form/select/GC-Cmp-Select";
  export default {
    components: {
        GcCmpFormSelect
    },
    data(){
        return{
            parentUrl: '/modules/wms/manage/warehouse',//列表页链接
            parentName: 'Wms-Warehouse-Stock',//列表页链接
            breadcrumb:[],//菜单
            warehouseType: "",//添加的仓库类型
            warehouseList: Mod_Warehouse_Types_Options,//仓库字典级
            warehouseObj:{},
            relationWsOptions:[],//关联仓库
            imgUrl:"", //分类图片
            locList: [], //仓位集合
        }
    },
    mounted(){
        //仓库类型
        this.warehouseType =sessionStorage.getItem("warehouseType");
        let title = '新增';
        let warehouseObj = JSON.parse(sessionStorage.getItem("warehouseInfo")); 
        if(warehouseObj){//编辑
            title = '编辑';
            this.getWarehouseDetail({
                id: warehouseObj.wsId
            })

        }
        //菜单导航
        this.breadcrumb = [
            {
                title: '仓库管理',
                url: this.parentUrl
            },
            {
                title: title,
                active: true
            }
        ]
        //不是主仓的时候获取关联仓库列表
        if(this.warehouseType != this.warehouseList[1].id){
            this.getRelationWsOptions()
        }
    },
    methods:{
        selectResWsEvent(e){
            let that = this;
            console.log(e)
        },
        async getWarehouseDetail(data){
           let res = await WmsWarehouseApi.oneWarehouse(data)
           if(!res.code && res.succ == 1){
            this.warehouseObj = res.result
            // let name = this.warehouseObj.name;
            //     this.warehouseObj.name = name.trim()
            //兼容后端 保存参数和返回参数不一致
            this.warehouseObj.name = this.warehouseObj.wsName.trim()
            this.warehouseObj.id = this.warehouseObj.wsId
            // this.warehouseObj.relationWsId = this.warehouseObj.relWsId

            if(res.result.locList && res.result.locList.length){
                this.locList = res.result.locList
            }
           }else{
                this.$notifyError(res.error);
           }
        },
        //保存仓库
        async saveWarehouse(){
            if(!this.warehouseObj.name){
                this.$notifyError("请填写仓库名称");
            }else if(!this.warehouseObj.relWsId && this.warehouseType != Mod_Warehouse_Types_Options[1].id){
                this.$notifyError("请选择关联仓库");
            }else{
                let name = this.warehouseObj.name;
                this.warehouseObj.name = name.trim()
                this.warehouseObj.locList = this.locList
                this.warehouseObj.type = this.warehouseType;
                let resp = await WmsWarehouseApi.saveWarehouse(this.warehouseObj);
                if(resp.succ == 1 && !resp.code){
                    this.$notifySuccess('保存成功');
                    this.cancle();
                }else{
                    this.$notifyError('保存失败' + (resp.error || ''));
                }      
            }    
        },
        // 确认取消 
        cancleAffirm(){
            this.$vs.dialog({
            type: "confirm",
            title: `请确认`,
            text: `是否确认取消`,
            acceptText: "确认",
            cancelText: "取消",
            accept: () => {
            this.cancle();
            },
        });
        },
        cancle(){
            //移除数据
            sessionStorage.removeItem("warehouseType");
            sessionStorage.removeItem("warehouseInfo");
            let data = sessionStorage.getItem('tabIndex')
            this.$router.push({name:this.parentName,params:{tabIndex:data}}).catch(() => {}) 
        },
        //获取关联仓库
        async getRelationWsOptions(){
            let whType = '';
            if(this.warehouseType == this.warehouseList[2].id){//分仓的关联仓库是主仓
                whType = this.warehouseList[1].id;
            }
            let resp = await WmsWarehouseApi.getWarehouseAll({
                    type: whType //仓位类型
            }); 
            let resList = resp.result;
            resList.map((item) =>{
                let obj = {};
                obj.id = item.wsId;
                obj.label = item.wsName;
                obj.bodyName = item.bodyName;
                obj.bodyId = item.bodyId;
                this.relationWsOptions.push(obj);
            });
        },

        //删除仓位
        delLoc(index){
          this.locList.splice(index,1)
        },

        addLoc(){
            this.locList.push({})
        }
    },
    watch:{
        "warehouseObj.relWsId"(val){
            let that = this;
            that.relationWsOptions.map(item => {
                if(item.id == val){
                    that.warehouseObj.bodyName = item.bodyName;
                }
            })
        }
    }
  }
</script>

<style lang="scss" scoped>
 @import '@/modules/commodity-sys/commodity.scss';
  .vs-col .redText{
      margin-right: 8px;
  }
  // 表单
  form{
    .vs-input, .gc-cmp-form-select{
        width: 200px;
        height: 38px;
        line-height: 24px;
    }
    .width200{
        width: 200px;
    }
    /deep/ .v-select{
        width: 195px;
    }
    .form-label{
        width: 70px;
        text-align: left;
    }
    .loc-container{
        margin: 40px 0 120px;
        .loc-item{
            padding-bottom: 20px;
            margin-bottom: 20px;
            border-bottom: 1px dashed #ddd;
        }
        .loc-del{
            color: rgb(64,144,255);
            cursor: pointer;
            &:hover{
                color: rgba(64,144,255, .8);
            }
        }
        .add-loc{
            padding: 0 !important;
            font-size: 12px;
            width: 290px;
            height: 40px;
        }
    }
  }
</style> 
